import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "./assets/Home.scss";

const LandingPage = () => {
    return(
        <div id="home">
            <section>
                <div>
                    <h3>So you want to travel to,</h3>
                    <h1>Space</h1>

                    <p>Let's face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back and relax because we'll give you a truly out of this world experience.</p>

                    {/* <p>Page Width: {page.width}</p> */}
                </div>

                <div>
                    <Link to='/Destination'><button type="button">Explore</button></Link>
                </div>
            </section>
        </div>
    );
}

export default LandingPage;